import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=4330ea03&scoped=true&lang=pug"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=4330ea03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4330ea03",
  null
  
)

export default component.exports